import { render, staticRenderFns } from "./DepartmentLinks.vue?vue&type=template&id=0fe82c72&scoped=true"
import script from "./DepartmentLinks.vue?vue&type=script&lang=js"
export * from "./DepartmentLinks.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fe82c72",
  null
  
)

export default component.exports